import { useEffect } from 'react';

import { getAccessToken } from '@/utils/accessToken';
import { validateToken } from '@/utils/tokenValidation';
import { logout } from '@/utils/logout';

export const useTimedTokenValidation = () => {
  useEffect(() => {
    const checkToken = async () => {
      const token = getAccessToken({ withLocalStorage: true });

      try {
        if (!(await validateToken(token))) {
          logout();
        }
      } catch (error) {
        console.error('Token validation failed:', error);
      }
    };

    checkToken();
    const interval = setInterval(checkToken, 30000);
    return () => clearInterval(interval);
  }, []);
};
